import React from "react";
const arrowIcon = require("./styles/arrow-icon.svg");
const previewIcon = require("./styles/preview-icon.svg");
const shareIcon = require("./styles/share-icon.svg");
const copyIcon = require("./styles/copy-icon.svg");
const tickIcon = require("./styles/tick-icon.svg");

export const Navbar = ({
  landingPageURL,
  showShareGalleryPopup,
  embedGalleryURL,
  toggleColorsPanel,
  handleSaveAndPublish,
  showPageColors
}: {
  landingPageURL: string;
  showShareGalleryPopup: () => void;
  embedGalleryURL: string;
  toggleColorsPanel: () => void;
  handleSaveAndPublish: (action: string) => void;
  showPageColors: boolean;
}) => {
  const copyEmbedCode = () => {
    navigator.clipboard.writeText(
      `<iframe src="${embedGalleryURL}" allow="camera; geolocation; clipboard-write" style="width: 98%;height: 800px; border: 1px solid #e6e7e8;"></iframe>`
    );
    // @ts-ignore
    toastr.success("Embed code copied");
  };

  return (
    <div className="org-config-nav">
      <p className="org-config-nav-p">
        CUSTOMISE <span className="hidden-sm hidden-xs hidden-md">PAGE</span>
      </p>
      <a
        href={`${landingPageURL}?preview=true`}
        target="_blank"
        className="org-config-preview-btn"
      >
        <img src={previewIcon} className="org-preview-icon" />
        Preview
      </a>
      <button
        className="gallery-share-btn hidden-sm hidden-xs hidden-md"
        onClick={() => showShareGalleryPopup()}
      >
        <img src={shareIcon} /> Share event gallery
      </button>
      <button
        className="gallery-copy-embed-btn hidden-sm hidden-xs hidden-md"
        onClick={copyEmbedCode}
      >
        <span id="before-copy">
          <img src={copyIcon} /> Copy
        </span>
        <span id="after-copy" style={{ display: "none" }}>
          <img src={tickIcon} /> Copied
        </span>{" "}
        embed code
      </button>
      <div className="gal-mobile-btns visible-sm visible-xs visible-md">
        <div className="gal-more-wrap dropdown">
          <button
            className="org-config-more-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            More <img src={arrowIcon} className="org-arrow-icon-inactive" />
          </button>
          <ul
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="dLabel"
          >
            <li>
              <a onClick={toggleColorsPanel}>
                Page colors{" "}
                <img
                  src={arrowIcon}
                  className="gal-dd-icon org-arrow-icon-right"
                />
              </a>
            </li>
            <li>
              <a
                className="gal-share-link"
                onClick={() => showShareGalleryPopup()}
              >
                Share event gallery{" "}
                <img src={shareIcon} className="gal-dd-icon" />
              </a>
            </li>
            <li>
              <a className="gal-embed-link" onClick={copyEmbedCode}>
                Copy embed code <img src={copyIcon} className="gal-dd-icon" />
              </a>
            </li>
          </ul>
        </div>
        <div className="gal-save-wrap dropdown">
          <a
            className="org-config-save-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Save <img src={arrowIcon} className="org-arrow-icon-inactive" />
          </a>
          <ul
            className="dropdown-menu dropdown-menu-right"
            aria-labelledby="dLabel"
          >
            <li>
              <a onClick={() => handleSaveAndPublish("save")}>Save Draft </a>
            </li>
            <li>
              <a
                onClick={() => handleSaveAndPublish("publish")}
                className="gal-share-link"
              >
                Save and Publish
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="org-config-div2 hidden-sm hidden-xs hidden-md">
        <button className="org-config-colors-btn" onClick={toggleColorsPanel}>
          Page Colors
          <img
            src={arrowIcon}
            className={
              "org-arrow-icon " +
              (showPageColors ? "" : "org-arrow-icon-inactive")
            }
          />
        </button>
        <button
          onClick={() => handleSaveAndPublish("save")}
          className="org-config-draft-btn"
        >
          Save Draft
        </button>
        <button
          onClick={() => handleSaveAndPublish("publish")}
          className="org-config-save-btn"
        >
          Save and Publish
        </button>
      </div>
    </div>
  );
};
